import {Component, OnInit} from '@angular/core';
import {ProjectService} from '../../../services/project.service';
import {IdService} from '../../../services/id.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {ObjectService} from 'src/app/services/object.service';
import {takeUntil} from 'rxjs/operators';
import {AventiObject} from 'src/app/models/AventiObject';
import {firstValueFrom, Subject} from 'rxjs';
import {SharedService} from 'src/app/services/shared.service';
import {MediaMatcher} from '@angular/cdk/layout';
import {environment} from 'src/environments/environment';
import {Key, KEY_VALUE} from 'src/app/components/field-scan/types';

type Page = { label: string, value: string, icon: string };

enum PAGE_VALUE {
  QR = 'qr',
  TEXT = 'text'
}

@Component({
  selector: 'app-object-search',
  templateUrl: './object-search.component.html',
  styleUrls: ['./object-search.component.css']
})

export class ObjectSearchComponent implements OnInit {
  projectId: string;
  projectName: string;
  objects: AventiObject[];
  objectsName: AventiObject[];
  objectsTfm: AventiObject[];
  objectsRds: AventiObject[];
  activeTab = 0;
  mobileQuery: MediaQueryList;
  DEFAULT_KEY = 'tfmTag';
  key: Key;
  keys: Key[] = [
    {label: 'Navn', value: KEY_VALUE.NAME, objects: undefined},
    {label: 'TFM', value: KEY_VALUE.TFM_TAG, objects: undefined},
    {label: 'RDS', value: KEY_VALUE.RDS_TAG, objects: undefined}
  ];
  page: Page;
  pages: Page[] = [
    {label: 'QR', value: PAGE_VALUE.QR, icon: 'qr_code_scanner'},
    {label: 'Navn', value: PAGE_VALUE.TEXT, icon: 'keyboard'}
  ];
  keyIndex: number = 0;
  initUpdateKey = true;
  warning: string | null = null;
  private ngUnsubscribe = new Subject();

  constructor(
    private idService: IdService,
    private projectService: ProjectService,
    private sharedservice: SharedService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    media: MediaMatcher,
    private objectService: ObjectService
  ) {
    this.projectId = this.idService.projectId();
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(params => {
      const pageValue = params.page;
      const keyValue = params.key;
      if (pageValue) {
        this.page = this.pages.find(p => p.value === pageValue) || this.pages[0];
      } else {
        this.page = this.pages.find(p => p.value === PAGE_VALUE.QR) || this.pages[0];
      }
      if (keyValue) {
        this.updateKey(keyValue);
      } else {
        this.key = this.keys.find(k => k.value === this.DEFAULT_KEY) || this.keys[1];
        this.updateKey(this.DEFAULT_KEY);
      }
    });
    this.projectName = (await firstValueFrom(this.projectService.getProjectById(this.projectId))).name || '';

    this.objects = await firstValueFrom(this.sharedservice.objects) ?? [];
    if (this.objects.length > 0) {
      this.setObjects();
    }

    this.objectService.rtdbGetObjects(this.projectId, this.ngUnsubscribe)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((objs: AventiObject[]) => {
        this.objects = objs;
        this.sharedservice.objects.next(this.objects);
        this.setObjects();
      });
  }

  onPageChange($event: Page): void {
    this.page = $event;
    this.updateQueryParam();
  }

  onKeyChange($event: number): void {
    this.key = this.keys[$event];
    this.updateQueryParam();
  }

  private updateQueryParam(): void {
    const currentUrl = this.router.url.split('?')[0];
    const params = { key: this.key.value, page: this.page.value };
    const queryString = new URLSearchParams(params).toString();
    this.location.replaceState(currentUrl, queryString);
  }

  updateKey(keyValue: string): void {
    this.initUpdateKey = false;
    this.keyIndex = this.keys.findIndex(k => k.value === keyValue);
    this.key = this.keys[this.keyIndex] || this.keys[1];
    this.warning = null;
    switch (keyValue) {
    case KEY_VALUE.NAME:
      this.warning = null;
      break;
    case KEY_VALUE.TFM_TAG:
      if (this.objectsTfm?.length === 0) {
        this.warning = 'Ingen TFM tag funnet i prosjektet. Legg til TFM tag før du søker.';
      }
      break;
    case KEY_VALUE.RDS_TAG:
      if (this.objectsRds?.length === 0) {
        this.warning = 'Ingen RDS tag funnet i prosjektet. Legg til RDS tag før du søker.';
      }
      break;
    default:
      this.warning = `Ugyldig søkenøkkel: ${keyValue}. Gyldige nøkler er 'name', 'tfmTag' eller 'rdsTag'.`;
    }
  }

  private setObjects() {
    this.objectsName = this.objects.filter(obj => obj.name);
    this.objectsTfm = this.objects.filter(obj => obj.tfmTag);
    this.objectsRds = this.objects.filter(obj => obj.rdsTag);
    this.keys[0].objects = this.objectsName;
    this.keys[1].objects = this.objectsTfm;
    this.keys[2].objects = this.objectsRds;
    this.key = this.keys[this.keyIndex] || this.keys[1];
    if (this.initUpdateKey) {
      this.updateKey(this.DEFAULT_KEY);
    }
  }

}
